import { Clock } from "lucide-react";

import { RecentSearch } from "../hooks/useRecentSearches";

type RecentSearchesProps = {
  items: RecentSearch[];
  onSelect: (query: string) => void;
};

export const RecentSearches = ({ items, onSelect }: RecentSearchesProps) => {
  if (items.length === 0) return null;

  return (
    <div>
      <h3 className="px-4 pb-2 pt-4 text-xs font-medium text-foreground-muted">
        Recent searches
      </h3>
      <div>
        {items.map((item) => (
          <button
            key={item.query}
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect(item.query);
            }}
            className="flex w-full items-center justify-between px-4 py-3 text-left transition-colors hover:bg-[#f2f7ff]"
          >
            <span className="flex items-center gap-1.5 overflow-hidden">
              <Clock className="size-4 shrink-0 text-foreground-muted" />
              <span className="truncate text-xs text-foreground">{item.query}</span>
            </span>
            <span className="shrink-0 text-xs text-foreground-muted">
              {item.docCount} {item.docCount === 1 ? "doc" : "docs"}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
